import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./navigationstyles.css";
import logo from "../../../assets/img/GG210.png";
import axios from "axios";
import AccountBox from "../accountbox/accountbox";
import Accountboxone from "../accountboxone/accountboxone";
import AccountBoxThree from "../accountboxthree/accountboxthree";
import AccountBoxTwo from "../accountboxtwo/accountboxtwo";
import { connect } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
// import { IoMdNotificationsOutline } from 'react-icons/io';

import { useHistory } from "react-router-dom";
import { API_AUTH, API_CANDIDATE } from "../../../utils/config";

function Navbar(props) {
  const [click, setClick] = useState(false);
  const [clickone, setClickOne] = useState(false);
  const [clickTwo, setClickTwo] = useState(false);
  const [clickthree, setClickthree] = useState(false);
  // logout = () => {
  //   localStorage.clear();
  //   sessionStorage.clear();
  // };

  const navRef = useRef();

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };
  const handleClick = () => {
    setClick(!click);
  };

  const handleClickone = () => {
    setClickOne(!clickone);
  };
  const handleClickTwo = () => {
    setClickTwo(!clickTwo);
  };

  const handleClickthree = () => {
    setClickthree(!clickthree);
  };

  const history = useHistory();

  const handleLogout = async () => {
    await axios
      .post(
        `${API_AUTH}/v1/api/auth/logout`,
        {},
        {
          withCredentials: true,
          crossOrigin: true,
          crossDomain: true,
        }
      )
      .then((response) => {
        console.log(response);
        if (response.data.ok) {
          window.location = "/signin";
        }
      })
      .catch((err) => {
        //  if (err.response && err.response.data.statusCode === 403) {
        //         history.push({
        //             pathname: "/signin",
        //         });
        //     }
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`${API_CANDIDATE}/v1/api/create-user`, { withCredentials: true })
      .then((res) => {
        console.log(res);

        if (res.data.ok === false) {
          history.push({
            pathname: "/validateuser",
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  console.log(props.profile, "chan");

  return (
    <>
      <header>
        <nav ref={navRef}>
          <Link to="/user" className="navbar-logo">
            <img src={logo} alt="GrowthGamut" />
          </Link>
          <div class="dropdown">
            <li className="nav-links pointer dropbtn" for="btnControl">
              Insights
            </li>
            <div class="dropdown-content dropdown-content">
              <a href="/dashboard/view_apply_jobs">My Dashboard</a>
            </div>
          </div>
          {/* <div class="dropdown">
  <button class="dropbtn" for="btnControl">Opportunities</button>
  <div class="dropdown-content">
    <a href="/dashboard/published_jobs">Jobs</a>
    <a href="/dashboard/matched_jobs">Matched Jobs</a>
  
  </div>
</div> */}
          <div class="dropdown">
            <li
              onMouseEnter={handleClickthree}
              className="nav-links pointer dropbtn"
              activeClassName="menu-active"
              for="btnControl"
            >
              Opportunities
            </li>
            <div class="dropdown-content opurtunities_flex">
              <a href="/dashboard/published_jobs">Jobs</a>
              <a href="/dashboard/matched_jobs">Matched Jobs</a>
            </div>
          </div>

          <li
            onMouseEnter={handleClickone}
            // exact
            // to="/user/marketplace/opportunities"
            className="nav-links pointer "
            activeClassName="menu-active"
          >
            Marketplace
          </li>

          <button className="nav_btn nav_close_btn" onClick={showNavbar}>
            <CloseIcon />
          </button>
        </nav>
        <button className="nav_btn nav_close_btn" onClick={showNavbar}>
          <MenuIcon />
        </button>

        <div class="dropdown2" style={{ marginLeft: "20px" }}>
          <li
            onMouseEnter={handleClick}
            style={{ margin: "0 0 0 1rem", listStyle: "none" }}
          >
            <div
              style={{
                background: `url(${API_CANDIDATE}/all/${props.profile.data.candPhoto})`,
                marginRight: "20px",
              }}
              className="navbar-pic-div dashround_res"
            >
              {" "}
            </div>
          </li>
          <div class="dropdown-content2 round_content">
            <a href="/dashboard/my_profile ">My Profile</a>
            <a href="/dashboard/PdfRender">View Resume</a>
            <a href="/dashboard/PrintSummary">View Summary Resume</a>
            <a href="/dashboard/uploadedResume">View Uploaded Resume</a>
            <a href="/uploadresume">Upload Resume</a>
            <a href="/dashboard/change_password">Change Password</a>

            <a onClick={handleLogout}>Logout</a>
          </div>
        </div>
      </header>

      {/* <nav className="navbar-sidebar">
        <div className="navbar-container nav_container_res">
          <Link to="/user" className="navbar-logo">
            <img src={logo} alt="GrowthGamut" />
          </Link>
          <div style={{ width: "900px" }}>
            <ul
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingLeft: "2rem",
                paddingRight: "2rem",
              }}
              className="nav-menu"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <li  onMouseEnter={handleClickTwo}
                className="nav-links pointer navtext"
                activeClassName="menu-active"
                >
                  
                    
                   
                    
                  
                    Insights
                 
                </li>
                <h6 style={{ justifyContent: "center" }}>
                  {clickTwo ? (
                    <AccountBoxTwo click={handleClickTwo} />
                  ) : null}
                </h6>
              </div>

              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <li  onMouseEnter={handleClickthree}
                    className="nav-links pointer navtext"
                    activeClassName="menu-active">
                
                   
                  
                    Opportunities
                  
                </li>
                <h6 style={{ width: "100%", justifyContent: "center" }}>
                  {clickthree ? (
                    <AccountBoxThree click={handleClickthree} />
                  ) : null}
                </h6>
              </div>

              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <li>
                  <Link
                    onMouseEnter={handleClickone}
                    // exact
                    // to="/user/marketplace/opportunities"
                    className="nav-links pointer navtext"
                    activeClassName="menu-active"
                  >
                    Marketplace
                  </Link>
                </li>

                <h6 className="mt-2 mr-2">
                  {clickone ? <Accountboxone click={handleClickone} /> : null}
                </h6>
              </div>
            </ul>
          </div>

          <li onMouseEnter={handleClick} style={{ margin: "0 0 0 1rem",listStyle:'none' }}>
            <div
              style={{
                background: `url(${API_CANDIDATE}/all/${props.profile.data.candPhoto})`,
              }}
              className="navbar-pic-div dashround_res"
            >
              {" "}
            </div>
          </li>
        </div>

        <h6 className="mt-2 mr-2">
          {click ? (
            <AccountBox click={handleClick} onClick={handleLogout} />
          ) : null}
        </h6>
      </nav> */}
    </>
  );
}
const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps)(Navbar);
